import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { IconDefinition, faMicrochipAi } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState } from 'react';

import 'components/desktop/_general/Tabs/Tabs.scss';

export type Tab = {
	name: string;
	content: JSX.Element;
	display?: boolean;
	ai?: boolean;
	dataComponentType?: string;
	icon?: IconDefinition;
};

interface IProps {
	tabs: Tab[];
	localStorageKey?: string;
	style?: React.CSSProperties;
	renderAsPills?: boolean;
}

const Tabs = (props: IProps) => {
	const [activeTab, setActiveTab] = useState<number>(0);
	const [activeTabName, setActiveTabName] = useState<string>(props.tabs.first().name);

	useEffect(() => {
		if (props.tabs.first().name !== activeTabName) {
			setStateFromActiveTabName();
		} else {
			setStateFromLocalStorage();
		}
	}, [props.tabs.length]);

	const setStateFromActiveTabName = (): void => {
		const newIndex = props.tabs.findIndex((x) => x.name === activeTabName);
		if (newIndex >= 0) {
			setActiveTab(newIndex);
		} else {
			setActiveTab(0);
			setActiveTabName(props.tabs.first().name);
		}
	};

	const setStateFromLocalStorage = (): void => {
		if (!props.localStorageKey) return;
		const value: string | null = localStorage.getItem(props.localStorageKey);
		if (!value) return;
		const initialActiveTab: number = Number(value);
		setActiveTab(initialActiveTab);
		setActiveTabName(props.tabs[initialActiveTab].name);
	};

	const handleClick = (tab: Tab, activeTabNumber: number): void => {
		setActiveTab(activeTabNumber);
		setActiveTabName(tab.name);
		if (props.localStorageKey)
			localStorage.setItem(props.localStorageKey, String(activeTabNumber));
	};

	if (props.renderAsPills)
		return (
			<div className="tab-container" style={props.style}>
			<nav className="d-flex flex-row flex-fill tabs-scrollable">
					{props.tabs.map((e: Tab, i: number) => {
						return (
							<div
								data-component-type={e.dataComponentType}
								key={i}
								onClick={() => handleClick(e, i)}
								className="flex-fill tab-button-pill"
								style={{
									backgroundColor: i === activeTab ? '#6066c1' : '',
									color: i !== activeTab ? '#6066c1' : 'white',
								}}
							>
								{e.icon && (
									<span style={{ paddingRight: '6px' }}>
										<FontAwesomeIcon icon={e.icon} />
									</span>
								)}
								<span>{e.name}</span>
								{e.ai && (
									<span style={{ paddingLeft: '5px' }}>
										<FontAwesomeIcon icon={faMicrochipAi as IconProp} />
									</span>
								)}
							</div>
						);
					})}
				</nav>
				<div>{props.tabs[activeTab].content}</div>
			</div>
		);
	return (
		<div className="tab-container" style={props.style}>
			<nav className="d-flex flex-row flex-fill tabs-scrollable">
				{props.tabs.map((e: Tab, i: number) => {
					return (
						<div
							data-component-type={e.dataComponentType}
							key={i}
							onClick={() => handleClick(e, i)}
							className="flex-fill tab-button"
							style={{
								color: i === activeTab ? '#6066c1' : 'black',
								borderBottom: i == activeTab ? '0.3rem solid transparent' : '',
								borderImage:
									i == activeTab
										? `linear-gradient( to right, #888ff9, #6066c1 ) 1`
										: '',
							}}
						>
							{e.icon && (
								<span style={{ paddingRight: '6px' }}>
									<FontAwesomeIcon icon={e.icon} />
								</span>
							)}
							<span>{e.name}</span>
							{e.ai && (
								<span style={{ paddingLeft: '5px' }}>
									<FontAwesomeIcon icon={faMicrochipAi as IconProp} />
								</span>
							)}
						</div>
					);
				})}
			</nav>
			<div>{props.tabs[activeTab].content}</div>
		</div>
	);
};

export default Tabs;
